<template>
  <div>
    <!--表格栏-->
    <el-table ref="kttable" :data="data.list" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange" @current-change="handleCurrentChange" @cell-click="cellClick" @sort-change="changeTableSort"
      v-loading="loading" element-loading-text="loading" v-auto-height:maxHeight='isAutoHeight ? 0 : -90'
      :max-height="maxHeight" :border="border" :stripe="stripe" :size="$size" :align="align" style="width:100%;" :show-summary="isSummary" :summary-method="summaryMethod" :row-class-name="tableRowClassName">
      <el-table-column type="selection" width="40" v-if="showCheckbox" fixed="left"></el-table-column>
      <el-table-column type="index" width="40" align="center" :index="indexMethod" v-if="showIndex"></el-table-column>
      <template v-for="(column) in columns">
        <el-table-column header-align="center" :align="column.align || 'center'" :prop="column.prop" :label="column.labelKey ? $t(column.labelKey) : column.label" :width="column.width" :min-width="column.minWidth || 120"
          :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter" :show-overflow-tooltip="showOverflowTooltip" :sortable="column.sortable==null?false:column.sortable">
          <template slot-scope="scope">
            <slot :name="column.prop" :obj="scope" v-if="column.show === 'template'"></slot>
            <span v-else-if="column.formatter">{{column.formatter(scope.row)}}</span>
            <el-tooltip v-else-if="column.showOverflowTooltip" effect="dark" :placement="column.showOverflowTooltipPlacement || top">
              <span style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; width: 100%; display: inline-block; text-align: center;">{{scope.row[column.prop]}}</span>
              <div slot="content" class="popperClass">{{scope.row[column.prop]}}</div>
            </el-tooltip>
            <span v-else>{{scope.row[column.prop]}}</span>
          </template>
        </el-table-column>
      </template>
      <slot></slot>
    </el-table>
    <!--分页栏-->
    <div class="el-table-toolbar" style="padding:10px;" v-if="isPaging">
      <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize" :page-sizes="pageSizes" :total="data.total"
        style="float:right;" @current-change="refreshPageRequest" @size-change="handleSizeChange">
      </el-pagination>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KtTable',
  components: {},
  props: {
    columns: Array, // 表格列配置
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 50, 100],
    },
    data: Object, // 表格分页数据
    size: {
      // 尺寸样式
      type: String,
      default: '',
    },
    align: {
      // 文本对齐方式
      type: String,
      default: 'left',
    },
    border: {
      // 是否显示边框
      type: Boolean,
      default: true,
    },
    stripe: {
      // 是否显示斑马线
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      // // 是否高亮当前行
      type: Boolean,
      default: true,
    },
    showOverflowTooltip: {
      // 是否单行显示
      type: Boolean,
      default: false,
    },
    showBatchDelete: {
      // 是否显示操作组件
      type: Boolean,
      default: true,
    },
    showCheckbox: {
      // 是否显示checkbox 是否可以选择 默认多选
      type: Boolean,
      default: false,
    },
    isSingleElection: {
      // 是否单选
      type: Boolean,
      default: false,
    },
    showIndex: {
      // 是否显示index
      type: Boolean,
      default: false,
    },
    cellClickOnCheck: {
      // 单行点击是否选中
      type: Boolean,
      default: false,
    },
    isPaging: {
      type: Boolean,
      default: true,
    },
    isSummary: {
      // 总计功能
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      // 总计方法
      type: Function,
    },
    isAutoHeight: {
      // 高度是否自适应
      type: Boolean,
      default: false,
    },
    tableRowClassName: {
      // 为 Table 中的某一行添加 class
      type: Function
    }
  },
  data() {
    return {
      // 分页信息
      pageRequest: {
        pageNum: 1,
        page: 1,
        pageSize: 10,
      },
      maxHeight: null, // 表格最大高度
      loading: false, // 加载标识
      selections: [], // 列表选中列
    }
  },
  watch: {
    '$i18n.locale': {
      handler(val) {
        // this.findPage()
        setTimeout(() => {
          this.$refs.kttable && this.$refs.kttable.doLayout()
        }, 50)
      },
    },
  },
  methods: {
    // 重新搜索数据
    searchPage() {
      this.refreshPageRequest(1)
    },
    // 分页查询
    findPage() {
      this.loading = true
      let callback = (res) => {
        setTimeout(() => {
          this.loading = false
          setTimeout(() => {
            this.$refs.kttable && this.$refs.kttable.doLayout()
          }, 50)
        }, 100)
      }
      this.$emit('findPage', {
        pageRequest: this.pageRequest,
        callback: callback,
      })
    },
    // 选择切换
    selectionChange(selections) {
      if (!this.showCheckbox) return // 不需要多选的 不做选中处理
      if (this.isSingleElection) {
        if (selections.length > 1) {
          var newRows = selections.filter((it, index) => {
            if (index == selections.length - 1) {
              this.$refs.kttable.toggleRowSelection(it, true);
              return true;
            } else {
              this.$refs.kttable.toggleRowSelection(it, false);
              return false;
            }
          });
          this.selections = newRows;
        } else {
          this.selections = selections;
        }
      } else {
        this.selections = selections
      }
      this.$emit('selectionChange', {
        selections: selections,
      })
    },
    changeTableSort(column) {
      this.$emit('changeTableSort', column.column)
    },
    // 选中当前列
    cellClick(row, column, cell, event) {
      if (this.cellClickOnCheck) {
        if (column.fixed == 'right' || column.fixed == 'left') return // 设置固定右侧按钮 不做选中处理
        let checked = this.selections.filter((item) => {
          return JSON.stringify(row) == JSON.stringify(item)
        })[0]
        this.isSingleElection && this.$refs.kttable.clearSelection()
        this.$refs.kttable.toggleRowSelection(row, !checked)
      }
    },
    // 选择切换
    handleCurrentChange(val) {
      // this.selections = [val]
      // 选中checkbox
      if (this.cellClickOnCheck) {
        this.$emit('handleCurrentChange', {
          val: val,
        })
      }
    },
    // 换页刷新
    refreshPageRequest(pageNum) {
      this.pageRequest.pageNum = pageNum
      this.pageRequest.page = pageNum
      this.findPage()
    },
    handleSizeChange(pageSize) {
      this.pageRequest.pageNum = 1
      this.pageRequest.page = 1
      this.pageRequest.pageSize = pageSize
      this.findPage()
    },
    indexMethod(index) {
      return (
        (this.pageRequest.pageNum - 1) * this.pageRequest.pageSize + index + 1
      )
    },
    toggleRowSelection(row, checked){
      this.$refs.kttable.toggleRowSelection(row, checked)
    },
    clearSelection() {
      this.$refs.kttable.clearSelection()
    }
  },
  mounted() {
    this.searchPage()
  },
}
</script>

<style>
.popperClass {
  max-width: 30vw;
  max-height: 60vh;
  overflow-y: scroll;
  line-height: 1.4;
}
.el-table .warning-row td {
  background: #fdf5e6 !important;
}

.el-table .success-row td {
  background: #f0f9eb !important;
}
</style>
